import IconMeal from "@Icons/ticket/amenities/meals/IconMeal";
import IconDog from "@Icons/ticket/amenities/pets/IconDog";
import ResponseIconType from "@/types/ResponseIcon.type";

function IconTicketAmenity(props: ResponseIconType) {
    const {
        title,
        customProps = {},
    } = props

    const matchedAmenities = {
        IconMeal,
        IconDog,
    }

    const AmenityIcon = matchedAmenities[title]

    if (AmenityIcon) {
        return (
            <AmenityIcon
                {...{...props, ...customProps}}
            />
        )
    }

    return null
}

export default IconTicketAmenity